<div class="flex items-center gap-5x" [formGroup]="formGroup">
  <span class="field-label text-sm min-w-fit text-grey-100" *ngIf="label">
    {{ label | translate }}:
  </span>

  <ng-select
    #select
    class="filter-select"
    [class.has-value]="hasValue"
    [formControlName]="for"
    [searchFn]="search"
    [appendTo]="appendTo"
    [loading]="loading"
    [items]="finalizedOptions"
    [bindValue]="value"
    [bindLabel]="labelField"
    [searchable]="readonly !== true && (searchable || url)"
    [clearSearchOnAdd]="true"
    [placeholder]="placeholder | translate"
    [class.disabled]="disabled"
    [virtualScroll]="virtualScroll"
    [clearable]="clearable"
    [loadingText]="loadingTranslated"
    (search)="find($event)"
    (open)="onOpen($event)"
    (close)="onClose($event)"
    (change)="onChange($event)"
    [dropdownPosition]="dropdownPosition"
    [closeOnSelect]="closeOnSelect"
  >
    <ng-template ng-label-tmp let-item="item" let-clear="clear">
      <div [class]="'ng-value-wrapper default ' + getItemClass(item)">
        <span class="ng-value-label">
          <span class="align-center flex flex-row">
            <svg-icon
              *ngIf="labelIconField"
              class="mr10 {{ labelIconClass }}"
              [key]="getItemIcon(item)"
              fontSize="16px"
            ></svg-icon>
            <span class="lxm-select-label-value">{{
              getItemValue(item) | translate
            }}</span>
          </span>
        </span>
        <small *ngIf="additionalField || additionalFieldLabelFn">
          {{ getAdditionalValue(item) }}
        </small>
        <span
          class="ng-value-icon right"
          (click)="clear(item)"
          aria-hidden="true"
          >×</span
        >
      </div>
    </ng-template>

    <ng-template ng-option-tmp let-item="item">
      <div [class]="'ng-value-wrapper default ' + getItemClass(item)">
        <span class="ng-value-label">
          <span class="align-center flex flex-row">
            <svg-icon
              *ngIf="labelIconField"
              class="mr10 {{ labelIconClass }}"
              [key]="getItemIcon(item)"
              fontSize="16px"
            ></svg-icon>
            <span class="align-center inline-flex flex-row">
              {{ getItemValue(item) }}
              <span class="pro-icon ml4" *ngIf="item.pro"></span>
            </span>
          </span>
        </span>
        <small *ngIf="additionalField || additionalFieldLabelFn">
          {{ getAdditionalValue(item) }}
        </small>
      </div>
    </ng-template>
  </ng-select>
</div>

<lxm-overlay
  *ngIf="overlay"
  name="select-overlay"
  (click)="select.close()"
></lxm-overlay>
